// User Logins
export const USER_LOGGING_IN = 'USER_LOGGING_IN';
export const USER_LOGGED_IN = 'USER_LOGGED_IN';

export const USER_LOGGING_OUT = 'USER_LOGGING_OUT';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';

// User Register
export const USER_REGISTERING = 'USER_REGISTERING';
export const USER_REGISTER_COMPLETED = 'USER_REGISTER_COMPLETED';

// User profile
export const SET_USER_LOGGED_USER_PROFILE = 'SET_USER_LOGGED_USER_PROFILE';
export const CLEAR_USER_LOGGED_USER_PROFILE = 'SET_USER_LOGGED_USER_PROFILE';